export default "__VITE_PUBLIC_ASSET__dfaa7e9e__"